export default __webpack_public_path__ + "static/media/me.e2ce03b4.jpg";